import { Box } from '@material-ui/core';
import { DocumentStatus, RequiredFile } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

import { DocumentStatusOptions } from '@/components/modules/Documentation/components/DocumentationDetails/constants/DocumentStatusOptions';
import { ActionDescriptionWrapper } from '@/components/modules/Documentation/components/DocumentationDetails/hooks/useRequiredFile';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { Text } from '@/components/shared/components/Text';

export const SetDocumentStatusForm = ({ requiredFile }: { requiredFile: RequiredFile }) => {
  const documentStatusWatcher = useFormContext()?.watch('documentStatus');
  return (
    <>
      <ActionDescriptionWrapper>
        <Text tId={'SET_DOCUMENT_STATUS_REQUIRED_DESCRIPTION'} />
      </ActionDescriptionWrapper>
      <Box display="flex" flexDirection="column" gridGap={16} pt={2}>
        <ReadOnlyDataRow value={requiredFile.description} labelTextId="REQUIRED_DOCUMENT_TYPE" underlined />
        <SelectFormField
          name={'documentStatus'}
          value={requiredFile.status}
          label={'STATUS'}
          selectOptions={DocumentStatusOptions}
        />
        {documentStatusWatcher === DocumentStatus.INCIDENCE && (
          <>
            <TextFormField label={'COMMENT'} name={'annotation'} />
          </>
        )}
      </Box>
    </>
  );
};
